/** CSS max-width token aligned with PageShell / wizard content on each route. */
export function contentMaxWidthForPath(pathname: string): string {
  switch (pathname) {
    case '/map':
      return 'var(--layout-max-map)';
    case '/assessment':
      return 'var(--panel-max-wide)';
    case '/planning-info':
    case '/questionnaire':
    case '/wizard':
      return 'var(--layout-max)';
    default:
      return 'var(--layout-max)';
  }
}
